(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shpflt-collection-menu"] && !Shopify.designMode) return;
  try {
    
  function initCollectionMenuCarousel(carouselWrapper) {
    const carousel = carouselWrapper.querySelector('[data-carousel]');
    const track = carouselWrapper.querySelector('[data-carousel-track]');
    const prevButton = carouselWrapper.querySelector('[data-carousel-prev]');
    const nextButton = carouselWrapper.querySelector('[data-carousel-next]');

    if (!carousel || !track || !prevButton || !nextButton) {
      return;
    }

    function updateNavigationState() {
      const scrollLeft = track.scrollLeft;
      const maxScroll = track.scrollWidth - track.clientWidth;
      const isScrollable = track.scrollWidth > track.clientWidth;
      const isAtStart = scrollLeft <= 1; // Allow 1px tolerance
      const isAtEnd = scrollLeft >= maxScroll - 1; // -1 for rounding issues

      // Hide controls if all items fit in view
      if (!isScrollable) {
        prevButton.classList.add('hidden');
        nextButton.classList.add('hidden');
        prevButton.setAttribute('aria-hidden', 'true');
        nextButton.setAttribute('aria-hidden', 'true');
        track.classList.remove('scrollable');
      } else {
        prevButton.classList.remove('hidden');
        nextButton.classList.remove('hidden');
        prevButton.setAttribute('aria-hidden', 'false');
        nextButton.setAttribute('aria-hidden', 'false');
        track.classList.add('scrollable');
        
        prevButton.disabled = isAtStart;
        prevButton.setAttribute('aria-disabled', isAtStart);
        nextButton.disabled = isAtEnd;
        nextButton.setAttribute('aria-disabled', isAtEnd);
      }
    }

    function scrollCarousel(direction) {
      const items = Array.from(track.querySelectorAll('.shpflt-collection-menu__item'));
      if (items.length === 0) return;

      // Get the currently visible item closest to center
      const trackRect = track.getBoundingClientRect();
      const trackCenter = trackRect.left + trackRect.width / 2;
      
      let targetItem = null;
      let minDistance = Infinity;
      let currentIndex = 0;

      items.forEach((item, index) => {
        const itemRect = item.getBoundingClientRect();
        const itemCenter = itemRect.left + itemRect.width / 2;
        const distance = Math.abs(itemCenter - trackCenter);
        
        if (distance < minDistance) {
          minDistance = distance;
          targetItem = item;
          currentIndex = index;
        }
      });

      // Find the next/previous item
      let nextIndex;
      if (direction === 'next') {
        nextIndex = Math.min(currentIndex + 1, items.length - 1);
      } else {
        nextIndex = Math.max(currentIndex - 1, 0);
      }

      const nextItem = items[nextIndex];
      if (!nextItem || nextIndex === currentIndex) return;

      // Calculate scroll position to center the item
      // Account for padding and ensure item is fully visible
      const itemWidth = nextItem.offsetWidth;
      const trackWidth = track.clientWidth;
      const padding = parseInt(getComputedStyle(track).paddingLeft) || 0;
      
      // Calculate position to center the item
      const itemOffsetLeft = nextItem.offsetLeft;
      const scrollPosition = itemOffsetLeft - (trackWidth / 2) + (itemWidth / 2) - padding;

      // Ensure we don't scroll beyond bounds
      const maxScroll = track.scrollWidth - track.clientWidth;
      const clampedScroll = Math.max(0, Math.min(scrollPosition, maxScroll));

      track.scrollTo({
        left: clampedScroll,
        behavior: 'smooth'
      });
    }

    // Button click handlers
    prevButton.addEventListener('click', () => {
      if (!prevButton.disabled) {
        scrollCarousel('prev');
      }
    });

    nextButton.addEventListener('click', () => {
      if (!nextButton.disabled) {
        scrollCarousel('next');
      }
    });

    // Scroll event handler
    track.addEventListener('scroll', updateNavigationState);

    // Keyboard navigation
    carousel.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft' && !prevButton.disabled) {
        e.preventDefault();
        scrollCarousel('prev');
      } else if (e.key === 'ArrowRight' && !nextButton.disabled) {
        e.preventDefault();
        scrollCarousel('next');
      }
    });

    // Window resize handler
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateNavigationState();
      }, 100);
    });

    // Initial state
    updateNavigationState();
  }

  // Initialize all carousels on page load
  function initAllCarousels() {
    const carouselWrappers = document.querySelectorAll('.shpflt-collection-menu__carousel-wrapper');
    carouselWrappers.forEach(initCollectionMenuCarousel);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }

  // Theme editor integration
  document.addEventListener('shopify:section:load', function(event) {
    const sectionId = event.detail.sectionId;
    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (section) {
      const carouselWrapper = section.querySelector('.shpflt-collection-menu__carousel-wrapper');
      if (carouselWrapper) {
        initCollectionMenuCarousel(carouselWrapper);
      }
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    const sectionId = event.detail.sectionId;
    // Clean up any listeners/resources if needed
  });

  document.addEventListener('shopify:section:select', function(event) {
    const sectionId = event.detail.sectionId;
    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (section) {
      // Keep section visible for the merchant
      section.style.display = '';
    }
  });

  document.addEventListener('shopify:section:deselect', function(event) {
    const sectionId = event.detail.sectionId;
    // No special handling needed
  });

  // Calculate header height including both rows
  function getHeaderHeight() {
    const header = document.querySelector('.shpflt-header');
    if (!header) {
      return parseInt(getComputedStyle(document.body).getPropertyValue('--header-height')) || 73;
    }
    
    // Get the total height of the header including both rows
    const row1 = header.querySelector('.shpflt-header__row-1');
    const row2 = header.querySelector('.shpflt-header__row-2');
    
    let totalHeight = 0;
    if (row1) {
      totalHeight += row1.offsetHeight;
    }
    if (row2) {
      const row2Style = getComputedStyle(row2);
      if (row2Style.display !== 'none' && row2Style.visibility !== 'hidden') {
        totalHeight += row2.offsetHeight;
      }
    }
    
    // Fallback to CSS variable if calculation fails
    if (totalHeight === 0) {
      totalHeight = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height')) || 73;
    }
    
    return totalHeight;
  }

  // Update sticky bar position
  function updateStickyBarPosition(stickyBar) {
    const headerHeight = getHeaderHeight();
    stickyBar.style.top = `calc(${headerHeight}px - 2px)`;
  }

  // Sticky Bar Functionality
  function initStickyBarCarousel(stickyBar) {
    const track = stickyBar.querySelector('[data-sticky-track]');
    const prevButton = stickyBar.querySelector('[data-sticky-prev]');
    const nextButton = stickyBar.querySelector('[data-sticky-next]');

    if (!track || !prevButton || !nextButton) {
      return;
    }

    function updateStickyNavigationState() {
      const scrollLeft = track.scrollLeft;
      const maxScroll = track.scrollWidth - track.clientWidth;
      const isScrollable = track.scrollWidth > track.clientWidth;
      const isAtStart = scrollLeft <= 1;
      const isAtEnd = scrollLeft >= maxScroll - 1;

      if (!isScrollable) {
        prevButton.classList.add('hidden');
        nextButton.classList.add('hidden');
        prevButton.setAttribute('aria-hidden', 'true');
        nextButton.setAttribute('aria-hidden', 'true');
      } else {
        prevButton.classList.remove('hidden');
        nextButton.classList.remove('hidden');
        prevButton.setAttribute('aria-hidden', 'false');
        nextButton.setAttribute('aria-hidden', 'false');
        
        prevButton.disabled = isAtStart;
        prevButton.setAttribute('aria-disabled', isAtStart);
        nextButton.disabled = isAtEnd;
        nextButton.setAttribute('aria-disabled', isAtEnd);
      }
    }

    function scrollStickyCarousel(direction) {
      const items = Array.from(track.querySelectorAll('.shpflt-collection-menu__sticky-item'));
      if (items.length === 0) return;

      const firstItem = items[0];
      const itemWidth = firstItem.offsetWidth;
      const gap = parseInt(getComputedStyle(track).gap) || 12;
      const scrollAmount = itemWidth + gap;

      if (direction === 'prev') {
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }

    prevButton.addEventListener('click', () => {
      if (!prevButton.disabled) {
        scrollStickyCarousel('prev');
      }
    });

    nextButton.addEventListener('click', () => {
      if (!nextButton.disabled) {
        scrollStickyCarousel('next');
      }
    });

    track.addEventListener('scroll', updateStickyNavigationState);

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateStickyNavigationState();
      }, 100);
    });

    updateStickyNavigationState();
  }

  function initStickyBarObserver() {
    // Only initialize on desktop
    if (window.innerWidth < 750) {
      return;
    }

    const stickyBars = document.querySelectorAll('[data-sticky-bar][data-sticky-enabled="true"]');
    
    stickyBars.forEach((stickyBar) => {
      const sectionId = stickyBar.dataset.sectionId;
      if (!sectionId) {
        return;
      }

      // Try multiple selectors to find the section
      let section = document.querySelector(`section[data-section-id="${sectionId}"].shpflt-collection-menu`);
      if (!section) {
        section = document.querySelector(`section[data-section-id="${sectionId}"]`);
      }
      if (!section) {
        // Try with shopify-section- prefix
        const prefixedId = sectionId.startsWith('shopify-section-') ? sectionId : `shopify-section-${sectionId}`;
        section = document.querySelector(`section[id="${prefixedId}"]`);
      }
      if (!section) {
        // Last resort: try to find by class
        section = document.querySelector(`.shpflt-collection-menu-section[data-section-id="${sectionId}"]`);
      }
      if (!section) {
        return;
      }

      // Skip if observer already exists
      if (stickyBar.dataset.observerInitialized === 'true') {
        return;
      }

      // Set initial position below header
      updateStickyBarPosition(stickyBar);
      
      // Update position on resize
      let resizeTimeout;
      const updatePosition = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          updateStickyBarPosition(stickyBar);
        }, 100);
      };
      window.addEventListener('resize', updatePosition);
      stickyBar._resizeHandler = updatePosition;

      // Function to check if section is scrolled past
      const checkSectionVisibility = () => {
        const rect = section.getBoundingClientRect();
        // Section is scrolled past when its bottom is above the viewport top
        // We want to show sticky bar when section is completely above viewport
        const isScrolledPast = rect.bottom <= 0;
        
        if (isScrolledPast) {
          // Section is scrolled past, show sticky bar
          updateStickyBarPosition(stickyBar);
          stickyBar.classList.add('visible');
          if (!stickyBar.dataset.carouselInitialized) {
            initStickyBarCarousel(stickyBar);
            stickyBar.dataset.carouselInitialized = 'true';
          }
        } else {
          // Section is still visible, hide sticky bar
          stickyBar.classList.remove('visible');
        }
      };

      // Use Intersection Observer to detect when section leaves viewport
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            // Section is not intersecting, check if it's above viewport
            const rect = section.getBoundingClientRect();
            if (rect.bottom <= 0) {
              // Section is above viewport (scrolled past), show sticky bar
              updateStickyBarPosition(stickyBar);
              stickyBar.classList.add('visible');
              if (!stickyBar.dataset.carouselInitialized) {
                initStickyBarCarousel(stickyBar);
                stickyBar.dataset.carouselInitialized = 'true';
              }
            }
          } else {
            // Section is intersecting (in view), hide sticky bar
            stickyBar.classList.remove('visible');
          }
        });
      }, {
        threshold: 0,
        rootMargin: '0px'
      });

      observer.observe(section);
      stickyBar.dataset.observerInitialized = 'true';
      stickyBar._observer = observer;

      // Check initial state after DOM is ready
      setTimeout(checkSectionVisibility, 300);

      // Add scroll listener as fallback (throttled)
      let scrollTimeout;
      const handleScroll = () => {
        if (scrollTimeout) {
          cancelAnimationFrame(scrollTimeout);
        }
        scrollTimeout = requestAnimationFrame(checkSectionVisibility);
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      stickyBar._scrollHandler = handleScroll;
    });
  }

  // Initialize sticky bar observer on page load
  function initStickyBarOnReady() {
    // Wait a bit for DOM to be fully ready
    setTimeout(() => {
      initStickyBarObserver();
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBarOnReady);
  } else {
    initStickyBarOnReady();
  }

  // Re-initialize on window resize (to handle desktop/mobile switching)
  let resizeObserverTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeObserverTimeout);
    resizeObserverTimeout = setTimeout(() => {
      const stickyBars = document.querySelectorAll('[data-sticky-bar]');
      stickyBars.forEach(bar => {
        if (window.innerWidth < 750) {
          bar.classList.remove('visible');
        }
      });
      if (window.innerWidth >= 750) {
        initStickyBarObserver();
      }
    }, 250);
  });

  // Re-initialize on section load
  document.addEventListener('shopify:section:load', function(event) {
    const sectionId = event.detail.sectionId;
    const section = document.querySelector(`section[data-section-id="${sectionId}"].shpflt-collection-menu`);
    if (section) {
      if (window.innerWidth >= 750) {
        // Reset observer initialization flag
        const stickyBar = document.querySelector(`[data-sticky-bar][data-section-id="${sectionId}"]`);
        if (stickyBar) {
          stickyBar.dataset.observerInitialized = 'false';
          if (stickyBar._observer) {
            stickyBar._observer.disconnect();
            stickyBar._observer = null;
          }
        }
        initStickyBarObserver();
      }
    }
  });

  // Clean up observers on section unload
  document.addEventListener('shopify:section:unload', function(event) {
    const sectionId = event.detail.sectionId;
    const stickyBar = document.querySelector(`[data-sticky-bar][data-section-id="${sectionId}"]`);
    if (stickyBar) {
      if (stickyBar._observer) {
        stickyBar._observer.disconnect();
        stickyBar._observer = null;
      }
      stickyBar.dataset.observerInitialized = 'false';
    }
  });

  } catch(e) { console.error(e); }
})();
})();
